
import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import PickerInputMixin from "@/mixins/PickerInputMixin.vue";

@Component({
  components: {}
})
export default class GelirGiderTurPicker extends Mixins(PickerInputMixin) {
  @Prop() gelirMi!: boolean | null;
  @Prop() rules!: string;
  @Prop({ default: false }) isVisible!: boolean;

  items: Array<any> = [];
  isLoading = false;

  declare selectedItem: any;
  declare input: () => void;

  get filteredItems() {
    return this.items.filter(item => item.editable);
  }

  mounted() {
    this.load();
  }

  @Watch('isVisible')
  onVisibleChange(newValue: boolean) {
    if (newValue) {
      this.load();
    }
  }

  @Watch('gelirMi')
  onGelirMiChange(newValue: boolean | null) {
    if (newValue !== null) {
      this.load();
    }
  }

  async load() {
    if (this.gelirMi === null) return;

    this.isLoading = true;

    try {
      const endpoint = this.gelirMi
          ? '/api/v1/kasa-hareketi-turu/filter?gelir=1'
          : '/api/v1/kasa-hareketi-turu/filter?gelir=0';

      const response = await this.$http.get(endpoint);
      this.items = response.data.data || response.data;
    } catch (error) {
      console.error('GelirGiderTurPicker load error:', error);
      this.items = [];
    } finally {
      this.isLoading = false;
    }
  }
}
